import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Image from 'next/image';
import { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { Container } from '../common/Container';

export default function CompanyLogos({ child_companies_logo, company_name }) {
  const swiperRef = useRef(null);

  const removeLogos = [
    '3aa7726a-a961-4575-bde1-01499504e66f',
    '43c0339e-19cf-4834-b316-11af8b457a40',
  ];

  const filteredLogos = child_companies_logo.filter(
    (logo) => !removeLogos.includes(logo.CompanyId),
  );

  return (
    <Container>
      <section className="flex flex-col items-center w-full py-20 relative">
        <div className="flex justify-center flex-grow p-4">
          <h1 className="relative text-2xl font-bold font-montserrat text-center text-black md:text-3xl lg:text-4xl bg-secundary bg-clip-text">
            Conheça alguns clientes que já foram além
          </h1>
        </div>
        <div className="grid grid-cols-9">
          <div className="flex justify-start w-full items-center">
            <button
              swiperref={swiperRef}
              onClick={() => swiperRef.current?.slidePrev()}
              className="w-12 h-12 transition-all duration-500 lg:hover:scale-95 rounded-lg border-2 flex justify-center items-center bg-white"
            >
              <ChevronLeftIcon className="w-6 h-6 text-gray-700" />
            </button>
          </div>
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[Navigation, Pagination, A11y, Autoplay]}
            grabCursor={true}
            loop={true}
            centeredSlides={false}
            slidesPerView={1}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 2,
              },
              1280: {
                slidesPerView: 4,
              },
            }}
            className="relative mt-10 h-[10rem] md:h-[20rem] col-span-7 max-w-full flex items-center justify-center"
            initialSlide={0}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
          >
            {filteredLogos.map((logo, index) => (
              <SwiperSlide key={index} className="flex justify-center h-full p-2 mx-auto">
                <div
                  className="h-full flex transform items-center justify-center mx-auto p-2 transition-transform
            hover:scale-105 max-w-[12.625rem] md:max-w-[17.5rem] rounded-md"
                >
                  <Image
                    src={logo?.Url}
                    unoptimized={true}
                    alt="Logo da empresa"
                    width={1}
                    height={1}
                    className="filter grayscale-[100%] w-[120px] h-auto lg:w-[240px]"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="flex justify-end items-center w-full">
            <button
              swiperref={swiperRef}
              onClick={() => swiperRef.current?.slideNext()}
              className="transition-all duration-500 lg:hover:scale-95 w-12 h-12 rounded-lg border-2 flex justify-center items-center bg-white"
            >
              <ChevronRightIcon className="w-6 h-6 text-gray-700" />
            </button>
          </div>
        </div>
      </section>
    </Container>
  );
}